<template>
  <div class="privilege-dialog">
    <el-dialog
      title="特权修改"
      :visible.sync="showPrivilegeDialog"
      width="400px"
      :before-close="closeDialog"
    >
      <el-form :model="form" label-width="110px" ref="ruleForm" :rules="rules" class="wrapper-form">
        <el-form-item label="特权修改理由" prop="changeReson">
          <el-input v-model="form.changeReson" placeholder="请输入特权修改理由"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
    props: {
        showPrivilegeDialog: {
            type: Boolean,
            default: function() {
                return false;
            }
        }
    },
    data() {
        return {
            form: {
                changeReson: ''
            },
            rules: {
                changeReson: [
                    { required: true, message: '请输入特权修改理由', trigger: ['blur'] }
                ]
            }
        };
    },
    methods: {
        confirm() {
            this.$refs['ruleForm'].validate(valid => {
                if (valid) {
                    this.$emit('privilegeConfirm', this.form.changeReson);
                    this.closeDialog();
                }
            });
        },
        closeDialog() {
            this.$emit('update:showPrivilegeDialog', false);
        }
    }
};
</script>
<style lang="less">
.privilege-dialog {
  .label {
    font-size: 14px;
  }
  .el-form-item__error {
    width: 150px;
  }
  .el-input {
    width: 220px;
  }
  .el-form-item {
    height: 35px;
    margin-bottom: 5px;
  }
  .el-form-item__content {
    height: 33px;
  }
}
</style>